import React from "react";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";

//
import { Dropdown , Form} from "react-bootstrap";

function ColumnVisibility({
  title,
  icon,
  allColumns,
  fit = false,
  full = false,
  align = "end",
}) {
  return (
    <Dropdown className="column-visibility" align={align}>
      <Dropdown.Toggle className={full ? "full" : ""}>
        {icon && <i className={`text-black ${icon}`}></i>}

        {title && <span className="title">{title}</span>}
      </Dropdown.Toggle>

      <Dropdown.Menu className={fit ? "fit" : ""}>
        <ScrollBar>
          {allColumns.map((column) => (
            <div className="item" key={column.id}>
              <Form.Check
                type="checkbox"
                id={column.id}
                label={column.Header}
                className="check-box"
                {...column.getToggleHiddenProps()}
              />
            </div>
          ))}
        </ScrollBar>
      </Dropdown.Menu>
    </Dropdown>
  );
}

ColumnVisibility.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  allColumns: PropTypes.array.isRequired,
  activeFilter: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  fit: PropTypes.bool,
  full: PropTypes.bool,
  align: PropTypes.string,
};

export default ColumnVisibility;
